import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectOnlyFlat = createSelector(selectJsonQuery, jsonQuery => getTermValue('only_flat')(jsonQuery));
